import React from 'react';
import { ImageIcon } from 'lucide-react';
import type { BcmPhoto } from '../../data/photos';
type PhotoFrameProps = {
  photo: BcmPhoto;
  className?: string;
  /** Tailwind aspect ratio utility, e.g. "aspect-[4/5]". */
  ratio?: string;
  rotate?: string;
};

/**
 * Renders a real BCM photograph. Until the real file URL is added to
 * data/photos.ts, the frame shows a neutral "Add Image here" placeholder —
 * no stock or generated people are ever substituted in.
 */
export function PhotoFrame({
  photo,
  className = '',
  ratio = 'aspect-[4/3]',
  rotate = ''
}: PhotoFrameProps) {
  return <figure className={`overflow-hidden rounded-[18px] border-2 border-brand-navy bg-brand-blue ${rotate} ${className}`} data-id="element-353" data-mp="269swd15xip5x">
      {photo.src ? <img src={photo.src} alt={photo.alt} loading="lazy" className={`${ratio} w-full object-cover`} data-id="element-354" data-mp="229sibhmqsfze" /> : <div className={`${ratio} flex w-full flex-col items-center justify-center gap-2 px-4 py-6 text-center`} data-id="element-355" data-mp="3dm30ku3v0tpl">
          <ImageIcon aria-hidden="true" className="h-6 w-6 text-brand-navy" data-id="element-356" data-mp="gv9u8sqsiv9f" />
          <p className="font-meta text-[13px] font-semibold text-brand-navy" data-id="element-357" data-mp="lqp8hlspmt6d">Add Image here</p>
        </div>}
    </figure>;
}